import { z } from "zod";
export const pottedPlantTypeSchema = z.enum([
    "Flower Start",
    "Vegetable Start",
    "Succulent",
    "Terrarium",
    "Outdoor Planter",
    "Forced Bulb",
    "Houseplant",
]);
export const legalPottedPlantTypes = pottedPlantTypeSchema.options;
export const pottedPlantTagSchema = z.enum([
    "native",
    "perennial",
    "annual",
    "biennial",
    "full-sun",
    "part-sun",
    "full-shade",
    "part-shade",
    "wet",
    "dry",
    "medium-moisture",
]);
export const pottedPlantTagLabels = {
    native: "Native",
    perennial: "Perennial",
    annual: "Annual",
    biennial: "Biennial",
    "full-sun": "Full Sun",
    "part-sun": "Partial Sun",
    "full-shade": "Full Shade",
    "part-shade": "Partial Shade",
    wet: "Wet",
    dry: "Dry",
    "medium-moisture": "Medium Moisture",
};
export function getPottedPlantTagLabel(tag) {
    var _a;
    return (_a = pottedPlantTagLabels[tag]) !== null && _a !== void 0 ? _a : tag;
}
//# sourceMappingURL=potted-plants.js.map